export function isEditPage(id: Number | undefined) {
    return Boolean(id) || id == 0;
  }
  